import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import $ from "jquery";


import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
const ViewSupplyChainOrders = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

    const [data, setData] = useState([]);
    const [dataConfirmed, setDataConfirmed] = useState([]);
    const [dataFinished, setDataFinished] = useState([]);
    const [dataInproduction, setDataInproduction] = useState([]);
    const [dataCancelled, setDataCancelled] = useState([]);
    const [dataDraft, setDataDraft] = useState([]);
    const [dataShipped, setDataShipped] = useState([]);
    const [dataDelivered, setDataDelivered] = useState([]);

  const [productionStatusOptions, setProductionStatusOptions] = useState([]);




  useEffect(() => {

 

    setPermission(FindModuleById(433)); 
    console.log(permission);

      axios
          .get("/helpers/supplychain-orders-status", {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            if (response.data.code === 200) {
              let orders_status = response.data.data.orders_status;
              setProductionStatusOptions(orders_status);
            } else {
              console.log("API response is not an array");
            }
          })
          .catch((error) => {
            console.log(error);
          });


    axios.get(`/contracts/view/${id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if(response.data.code === 200) {
        setValue(response.data.data.contract);
        const order_id = response.data.data.contract.id;
            if(order_id !=""){
              axios
              .get(`/orders-by-contract/${order_id}`,  {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                if (response.data.code === 200) {
                  
                  let all_orders  =response.data.data.orders;
                  let order_Confirmed = [];
                  let order_Finished = [];
                  let order_InProcess = [];
                  let order_Draft = [];
                  let order_Cancelled = [];
                  let order_Shipped = [];
                  let order_Delivered = [];
                all_orders.forEach((order) => {
                    switch (order.order_status) {
                      case 1:
                        order_Confirmed.push(order);
                      break;
                      case 2:
                        order_Finished.push(order);
                      break;
                      case 3:
                        order_InProcess.push(order);
                      break;
                      case 4:
                        order_Draft.push(order);
                      break;
                      case 5:
                        order_Cancelled.push(order);
                      break;
                      case 6:
                        order_Shipped.push(order);
                      break;
                      case 7:
                        order_Delivered.push(order);
                      break;
                    
                      default:
                        break;
                    }
                  });
                  setData(all_orders);
                  setDataConfirmed(order_Confirmed);
                  setDataFinished(order_Finished);
                  setDataInproduction(order_InProcess);
                  setDataDraft(order_Draft);
                  setDataCancelled(order_Cancelled);
                  setDataShipped(order_Shipped);
                  setDataDelivered(order_Delivered);

                } else {
                  console.log("API response is not an array");
                }
              })
              .catch((error) => {
                console.log(error);
              });
            }
      }
    })
    .catch((error) => {
      console.log(error);
    });



       
  }, [id]);


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const OrderStatusCell = ({ row,  changeOrderStatus}) => {
         console.log(productionStatusOptions);
    console.log(row.original.order_status);
      if(row.original.order_status === 1 || row.original.order_status === 2 || row.original.order_status === 6 || row.original.order_status === 7){
         return (
      <div className="btn-group custom-table-btn-group">
        <button
          type="button"
          className="btn btn-block dropdown-toggle me-1"
          id={`status-all-${row.original.id}`}
          style={{
            backgroundColor: row.original.status.bg_color,
            color: row.original.status.color,
          }}
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {row.original.status ? row.original.status.title : ''}
        </button>
        <div className="dropdown-menu">
          {productionStatusOptions &&
            productionStatusOptions.map((shipp) => (
              <button
                key={shipp.id}
                className="dropdown-item btn btn-block"
                style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
              >
                {shipp.title}
              </button>
            ))}
        </div>
      </div>
    );
        
      }else{
      return (
        <button
          type="button"
          className="btn btn-block  me-1"
          style={{
            backgroundColor: row.original.status.bg_color,
            color: row.original.status.color,
          }}
        
        >
          {row.original.status ? row.original.status.title : ''}
        </button>
   
    );
      }
    
   };
   
 
   OrderStatusCell.propTypes = {
   row: PropTypes.shape({
     original: PropTypes.shape({
       id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
       order_status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // ✅ Added this line
       status: PropTypes.shape({
         title: PropTypes.string,
         bg_color: PropTypes.string,
         color: PropTypes.string,
       }),
     }).isRequired,
   }).isRequired,
   statusOptions: PropTypes.arrayOf(
     PropTypes.shape({
       id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
       title: PropTypes.string.isRequired,
       bg_color: PropTypes.string,
       color: PropTypes.string,
     })
   ).isRequired,
   changeOrderStatus: PropTypes.func.isRequired,
 };


  
// const updateDate = async (order_detail, type) => {
//   console.log("order_detail");
//   console.log(order_detail.container_number);
//   const { value: formValues } = await Swal.fire({
//     title: 'Update Loading Details',
//     html: `
//       <div style="display: grid;"> 
//         <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Loading Date</label>
//         <input type="date" id="datePicker"  value="${order_detail.loading_date}"  class="swal2-input" placeholder="Loading Date">
        
//         <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> Container Number</label>
//         <input type="text" id="containerNumber" value="${order_detail.container_number}"  class="swal2-input" placeholder="Container Number">
        
//         <label style="text-align: left; padding-left: 6px;margin-bottom:3px;"> ETA Date</label>
//         <input type="date" id="etaDate"  value="${order_detail.eta_date}"   class="swal2-input" placeholder="ETA Date">

//       </div>
//     `,
//     showCancelButton: true,
//     confirmButtonText: 'Update',
//     cancelButtonText: 'Cancel',
//     customClass: "swal-orders",
//     focusConfirm: false,
//     preConfirm: () => {
//       const date = document.getElementById('datePicker').value;
//       const container = document.getElementById('containerNumber').value.trim();
//       const eta = document.getElementById('etaDate').value;

//       if (!date || !container || !eta ) {
//         Swal.showValidationMessage('All fields are required');
//         return false;
//       }

//       return { date, container, eta };
//     }
//   });

//   if (formValues) {
//     console.log('Submitted Values:', formValues);

//     axios.get(`/supplychain-orders/update-loading-detail/${order_detail.id}/${formValues.date}`, {
//       headers: {
//         Authorization: `Bearer ${Authtoken}`,
//         Apitoken: Apitoken
//       },
//       params: {
//         date: formValues.date,
//         container: formValues.container,
//         eta: formValues.eta
//       }
//     })
//     .then((response) => {
//       console.log(response);
//       if (response.data.code === 200) {
//         $(`#button-${type}-${order_detail.id}`).text(response.data.data.date);
//         Swal.fire('Changed!', 'Loading Details Updated Successfully.', 'success');
//         const order_id = id;
//             if(order_id !=""){
//               axios
//               .get(`/orders-by-contract/${order_id}`,  {
//                 headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
//               })
//               .then((response) => {
//                 if (response.data.code === 200) {
                  
//                   let all_orders  =response.data.data.orders;
//                   let order_Confirmed = [];
//                   let order_Finished = [];
//                   let order_InProcess = [];
//                   let order_Draft = [];
//                   let order_Cancelled = [];
//                   let order_Shipped = [];
//                   let order_Delivered = [];
//                 all_orders.forEach((order) => {
//                     switch (order.order_status) {
//                       case 1:
//                         order_Confirmed.push(order);
//                       break;
//                       case 2:
//                         order_Finished.push(order);
//                       break;
//                       case 3:
//                         order_InProcess.push(order);
//                       break;
//                       case 4:
//                         order_Draft.push(order);
//                       break;
//                       case 5:
//                         order_Cancelled.push(order);
//                       break;
//                       case 6:
//                         order_Shipped.push(order);
//                       break;
//                       case 7:
//                         order_Delivered.push(order);
//                       break;
                    
//                       default:
//                         break;
//                     }
//                   });
//                   setData(all_orders);
//                   setDataConfirmed(order_Confirmed);
//                   setDataFinished(order_Finished);
//                   setDataInproduction(order_InProcess);
//                   setDataDraft(order_Draft);
//                   setDataCancelled(order_Cancelled);
//                   setDataShipped(order_Shipped);
//                   setDataDelivered(order_Delivered);

//                 } else {
//                   console.log("API response is not an array");
//                 }
//               })
//               .catch((error) => {
//                 console.log(error);
//               });
//             }             
        
//       } else {
//         Swal.fire('Error', 'Update failed. Please try again.', 'error');
//       }
//     })
//     .catch((error) => {
//       console.error(error);
//       Swal.fire('Error', 'Something went wrong while updating.', 'error');
//     });
//   }
// };


   const ProductionDateCell = ({ row, permission, updateDate }) => {
    const { original } = row;
  
    return (
      <div>
        {permission?.update === 1 ? (
          <button
            className="btn btn-primary btn-block"
            id={`button-all-${original.id}`}
            onClick={() => updateDate(original, 'all')}
          >
            {original.loading_date ?? 'Update Date'}
          </button>
        ) : (
          <span>{original.loading_date ?? 'N/A'}</span>
        )}
      </div>
    );
  };
  
  
  // ✅ Define PropTypes
  ProductionDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        loading_date: PropTypes.string,
      }).isRequired,
    }).isRequired,
    permission: PropTypes.shape({
      update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    updateDate: PropTypes.func.isRequired,
  };
  

  const columns = [
    {
      header: 'PO Number',
      accessorFn: (row) => `${row.po_number}`,
     },
    {
      header: 'Customer',
      accessorFn: (row) => `${row.customer_detail ? row.customer_detail.company_name : ''}`,
    },
    {
      header: 'Contract',
      accessorFn: (row) => `${row.contract_detail ? row.contract_detail.contract_number : ''}`,
    },
      // {
      //   header: 'Loading Date',
      //   accessorFn: (row) => row.loading_date || '',
      //   Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      // },

      {
      // accessorKey: 'container_number', //normal accessorKey
      accessorFn: (row) => `${row.packing ? row.packing.date_of_loading : ''}`,
      header: 'Loading Date',
    }, 
     {
      // accessorKey: 'container_number', //normal accessorKey
      accessorFn: (row) => `${row.packing ? row.packing.container_number : ''}`,
      header: 'Container Number',
    },
        {
      // accessorKey: 'eta_date', //normal accessorKey
      accessorFn: (row) => `${row.packing ? row.packing.eta : ''}`,
      header: 'ETA Date',
    },
        {
      header: 'Order Status',
      accessorFn: (row) => `${row.status ? row.status.title : ''}`,
      Cell: (props) => <OrderStatusCell {...props}  changeOrderStatus={changeOrderStatus}  />,
    },
    {
      accessorKey: 'quantity', //normal accessorKey
      header: 'Quantity',
    },
    {
      accessorKey: 'lot_number', //normal accessorKey
      header: 'Lot Number',
    },
    {
      header: 'Processing Line',
      accessorFn: (row) => `${(row.order_location)?row.order_location.title:""} `,
    },
  
    {
      header: 'Shipping Address',
      accessorFn: (row) => `${row.ship_address2 ? row.ship_address2.name : ''}`,
    },
   
    {
      header: 'Shipping method',
      accessorFn: (row) => `${row.shipping_method ? row.shipping_method : ''}`,
    },
    {
      header: 'Loading Type',
      accessorFn: (row) => `${row?.loading_type === 2 ? 'Pallets Loaded' : 'Floor Loaded'}`,
    },

    {
      header: 'Created By',
      accessorFn: (row) =>
        `${row.createdby ? row.createdby.first_name + ' ' + row.createdby.last_name : ''}`,
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        `${row.updatedby ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ''}`,
    },
    {
      header: 'Updated At',
      accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
    },
  ];
  
 

      
          const formatDateTime = (isoString) => {
            const date = new Date(isoString);
          
            // Get the components
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, '0');
          
            // Determine AM/PM
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert to 12-hour format
          
            return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
          };
    
    const changeOrderStatus = (user_id, status,type) =>{

    Swal.fire({
      title: 'Do you want Change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/supplychainorders/change-status/${user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              console.log(response.data.data.order_status);
              if (response.data.code === 200) {
                $("#status-"+type+"-"+user_id).text(response.data.data.order_status.title);
                $("#status-"+type+"-"+user_id).css('background-color',response.data.data.order_status.bg_color);
                $("#status-"+type+"-"+user_id).css('color',response.data.data.order_status.color);

                const order_id = id;
                                            if(order_id !=""){
                                              axios
                                              .get(`/orders-by-contract/${order_id}`,  {
                                                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                                              })
                                              .then((response) => {
                                                if (response.data.code === 200) {
                                                  
                                                  let all_orders  =response.data.data.orders;
                                                  let order_Confirmed = [];
                                                  let order_Finished = [];
                                                  let order_InProcess = [];
                                                  let order_Draft = [];
                                                  let order_Cancelled = [];
                                                  let order_Shipped = [];
                                                  let order_Delivered = [];
                                                all_orders.forEach((order) => {
                                                    switch (order.order_status) {
                                                      case 1:
                                                        order_Confirmed.push(order);
                                                      break;
                                                      case 2:
                                                        order_Finished.push(order);
                                                      break;
                                                      case 3:
                                                        order_InProcess.push(order);
                                                      break;
                                                      case 4:
                                                        order_Draft.push(order);
                                                      break;
                                                      case 5:
                                                        order_Cancelled.push(order);
                                                      break;
                                                      case 6:
                                                        order_Shipped.push(order);
                                                      break;
                                                      case 7:
                                                        order_Delivered.push(order);
                                                      break;
                                                    
                                                      default:
                                                        break;
                                                    }
                                                  });
                                                  setData(all_orders);
                                                  setDataConfirmed(order_Confirmed);
                                                  setDataFinished(order_Finished);
                                                  setDataInproduction(order_InProcess);
                                                  setDataDraft(order_Draft);
                                                  setDataCancelled(order_Cancelled);
                                                  setDataShipped(order_Shipped);
                                                  setDataDelivered(order_Delivered);
                
                                                } else {
                                                  console.log("API response is not an array");
                                                }
                                              })
                                              .catch((error) => {
                                                console.log(error);
                                              });
                                            }

            
                Swal.fire(
                  'Changed!',
                  'Order Status has been changed Successfully.',
                  'success'
                );
                // setTimeout(() => {
                //  // window.location.href = "/orders";
                // }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });


   
  
  }
  
 
  
    let raw_data_invoice ='';
     if(value.file){
       AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
       AWS.config.update({
       accessKeyId: AWS_ACCESS_KEY_ID,
       secretAccessKey: AWS_SECRET_ACCESS_KEY,
       region: AWS_DEFAULT_REGION,
       signatureVersion: 'v4',
       });
       const s3 = new AWS.S3();
       var params = {Bucket: AWS_BUCKET, Key: value.file};
       raw_data_invoice = s3.getSignedUrl('getObject', params);
     
     }




  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Supply Chain Orders</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/supplychainorders">Contracts</Link>
                    </li>
                    <li className="breadcrumb-item active">View Supply Chain Orders</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                {permission && permission.list === 1 && (
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">View Contract Information</h4>
                     
                      
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th className="p-3">Contract Number</th>
                            <td className="p-3">{value.contract_number}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Customer</th>
                            <td className="p-3">
                              {value.customer_detail ? value.customer_detail.company_name : ""}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Product</th>
                            <td className="p-3">
                              {value.producttype ? value.producttype.title : ""}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Price</th>
                            <td className="p-3">{value.price}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Quantity</th>
                            <td className="p-3">{value.quantity}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Status</th>
                            <td className="p-3">
                              {value.contractstatus ? value.contractstatus.title : ""}
                            </td>
                          </tr>
                            <tr>
                          <th className="p-3">File</th>
                          <td className="p-3">
                           {raw_data_invoice != '' && (
                             
                                <a
                                  className="btn btn-primary invoicebtn"
                                  href={raw_data_invoice}
                                  target="_blank"
                                   rel="noopener noreferrer"
                                  download
                                >
                                  Download
                                </a>
                             
                          )}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    
                    </div>
                  </div>
                )}
              </div>
            </div>

             <div className="row">
            <div className="col-sm-12">
            {permission && permission.list === 1 && (
            <section className="comp-section order-listing-page">
                <div className="row">
                <div className="col-md-12">
                    <div className="card bg-white">
                    
                    <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-bottom">
                         
                         <li className="nav-item">
                            <a className="nav-link active" href="#all-orders" data-bs-toggle="tab">All Orders ({data.length})</a>                                  
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataConfirmed" data-bs-toggle="tab"> Confirmed Orders ({dataConfirmed.length})</a>                                   
                        </li>                    
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataFinished" data-bs-toggle="tab"> Fnished Orders ({dataFinished.length})</a>                                   
                        </li>                   
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataInproduction" data-bs-toggle="tab"> In Process Orders ({dataInproduction.length})</a>                                   
                        </li>                    
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataDraft" data-bs-toggle="tab"> Draft Orders ({dataDraft.length})</a>                                   
                        </li>                   
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataCancelled" data-bs-toggle="tab"> Cancelled Orders ({dataCancelled.length})</a>                                   
                        </li>                 
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataShipped" data-bs-toggle="tab"> Shipped Orders ({dataShipped.length})</a>                                   
                        </li>                 
                        <li className="nav-item">
                            <a className="nav-link" href="#list-dataDelivered" data-bs-toggle="tab"> Delivered Orders ({dataDelivered.length})</a>                                   
                        </li>                    
                                    
                                         
                        </ul>
                        <div className="tab-content">
                     
                        <div className="tab-pane show active" id="all-orders">
                            <div className="row"  id="listing-followup-groupby" >
                              <div className="col-sm-12" >
                              <div className="card card-table">
                                <div className="card-body">
                                  <div className="table-responsive">
                                  <MaterialReactTable columns={columns} data={data} 
                                        enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                       
                                      
                                      />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane " id="list-dataConfirmed">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataConfirmed} 
                                         enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                      
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                
                        
                        <div className="tab-pane " id="list-dataFinished">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataFinished} 
                                         enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                      
                                        
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                
                        
                        <div className="tab-pane " id="list-dataInproduction">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataInproduction} 
                                          enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                        <div className="tab-pane " id="list-dataDraft">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataDraft} 
                                          enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                        <div className="tab-pane " id="list-dataCancelled">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataCancelled} 
                                          enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                    
                        <div className="tab-pane " id="list-dataShipped">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataShipped} 
                                          enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                      
                        <div className="tab-pane " id="list-dataDelivered">
                          <div className="row"   id="listing-followup">
                            <div className="col-sm-12">
                              <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">

                                    <MaterialReactTable columns={columns} data={dataDelivered} 
                                           enableColumnOrdering
                                        enablePinning
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
                                      
                                       
                                        />
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>                                

                                     
                     
                                                     
                        
                        </div>                             
                    </div>
                    </div>
                </div>
                </div>
            </section>
            )}
             
            </div>
          </div> 
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSupplyChainOrders;